import React, {useEffect, useMemo, useRef, useState} from "react";
import * as PropTypes from "prop-types";
import CustomMenuItems from "./CustomMenuItems";
import CustomMenuScroll from "./CustomMenuScroll";
import styles from "./CustomMenu.module.scss";


export default function CustomMenu({customMenuItems}) {
  const menuRef = useRef();
  const [activeItem,setActiveItem] = useState(null)

  return (
    <nav className={styles.customMenu} ref={menuRef}>
      <ul>
        <CustomMenuItems items={customMenuItems} setActiveItem={setActiveItem}/>
      </ul>
      <CustomMenuScroll activeItem={activeItem} menuRef={menuRef}/>
    </nav>
  )
}


CustomMenu.propTypes = {
  customMenuItems: PropTypes.array
};
